import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17d67cea"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "card",
  style: {"margin-bottom":"15px","margin-top":"10px","width":"100%"}
}
const _hoisted_2 = { class: "card-header card-header-stretch" }
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = { class: "nav nav-tabs nav-line-tabs nav-stretch fs-5 border-0" }
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = ["click"]
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = ["click"]
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = ["click"]
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = ["click"]
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = ["click"]
const _hoisted_15 = { class: "card-body" }
const _hoisted_16 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bullet me-5" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"10px"} }, "Fiat", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bullet me-5" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"10px"} }, "Crypto", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bullet me-5" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"10px"} }, "Fiat", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bullet me-5" }, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"10px"} }, "Crypto", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { style: {"margin-top":"10px"} }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Click one of currency tabs to view more")
], -1))
const _hoisted_29 = { style: {"margin-top":"20px"} }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  style: {"height":"16px","width":"16px","color":"grey"},
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg",
  "data-v-ba633cb8": ""
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M768 832a128 128 0 0 1-128 128H192A128 128 0 0 1 64 832V384a128 128 0 0 1 128-128v64a64 64 0 0 0-64 64v448a64 64 0 0 0 64 64h448a64 64 0 0 0 64-64h64z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M384 128a64 64 0 0 0-64 64v448a64 64 0 0 0 64 64h448a64 64 0 0 0 64-64V192a64 64 0 0 0-64-64H384zm0-64h448a128 128 0 0 1 128 128v448a128 128 0 0 1-128 128H384a128 128 0 0 1-128-128V192A128 128 0 0 1 384 64z"
  })
], -1))
const _hoisted_32 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_33 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_34 = { key: 0 }
const _hoisted_35 = /*#__PURE__*/_createStaticVNode("<div class=\"row g-5\" style=\"margin-top:15px;\" data-v-17d67cea><div class=\"col-lg-4\" data-v-17d67cea><div class=\"card card-stretch shadow mb-5\" data-v-17d67cea><div class=\"card-header\" data-v-17d67cea><h3 class=\"card-title\" data-v-17d67cea>Allocation</h3></div><div class=\"card-body\" data-v-17d67cea>Lorem Ipsum is simply dummy text</div><div class=\"card-footer\" data-v-17d67cea>Footer</div></div></div><div class=\"col-lg-4\" data-v-17d67cea><div class=\"card card-stretch-50 shadow mb-5\" data-v-17d67cea><div class=\"card-header\" data-v-17d67cea><h3 class=\"card-title\" data-v-17d67cea>Ongoing Check Point</h3></div><div class=\"card-body\" data-v-17d67cea>Lorem Ipsum is simply dummy text</div><div class=\"card-footer\" data-v-17d67cea>Footer</div></div><div class=\"card card-stretch-50 shadow mb-5\" data-v-17d67cea><div class=\"card-header\" data-v-17d67cea><h3 class=\"card-title\" data-v-17d67cea>Activation Control </h3></div><div class=\"card-body\" data-v-17d67cea>Lorem Ipsum is simply dummy text</div><div class=\"card-footer\" data-v-17d67cea>Footer</div></div></div><div class=\"col-lg-4\" data-v-17d67cea><div class=\"card card-stretch-33 shadow mb-5\" data-v-17d67cea><div class=\"card-header\" data-v-17d67cea><h3 class=\"card-title\" data-v-17d67cea>Risk Profile</h3></div><div class=\"card-body\" data-v-17d67cea>Lorem Ipsum is simply dummy text</div><div class=\"card-footer\" data-v-17d67cea>Footer</div></div><div class=\"card card-stretch-33 shadow mb-5\" data-v-17d67cea><div class=\"card-header\" data-v-17d67cea><h3 class=\"card-title\" data-v-17d67cea>Transaction Monitoring </h3></div><div class=\"card-body\" data-v-17d67cea>Lorem Ipsum is simply dummy text</div><div class=\"card-footer\" data-v-17d67cea>Footer</div></div><div class=\"card card-stretch-33 shadow mb-5\" data-v-17d67cea><div class=\"card-header\" data-v-17d67cea><h3 class=\"card-title\" data-v-17d67cea>Owner</h3></div><div class=\"card-body\" data-v-17d67cea>Lorem Ipsum is simply dummy text</div><div class=\"card-footer\" data-v-17d67cea>Footer</div></div></div></div><div class=\"row g-5\" data-v-17d67cea><div class=\"col-lg-4\" data-v-17d67cea><div class=\"card card-stretch shadow mb-5\" data-v-17d67cea><div class=\"card-header\" data-v-17d67cea><h3 class=\"card-title\" data-v-17d67cea>Agent</h3></div><div class=\"card-body\" data-v-17d67cea>Lorem Ipsum is simply dummy text</div><div class=\"card-footer\" data-v-17d67cea>Footer</div></div></div><div class=\"col-lg-4\" data-v-17d67cea><div class=\"card card-stretch shadow mb-5\" data-v-17d67cea><div class=\"card-header\" data-v-17d67cea><h3 class=\"card-title\" data-v-17d67cea>Pricing</h3></div><div class=\"card-body\" data-v-17d67cea>Lorem Ipsum is simply dummy text</div><div class=\"card-footer\" data-v-17d67cea>Footer</div></div></div></div>", 2)
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Operation Account", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator my-10" }, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Transaction Account(s)", -1))
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  style: {"height":"16px","width":"16px","color":"grey"},
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg",
  "data-v-ba633cb8": ""
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M768 832a128 128 0 0 1-128 128H192A128 128 0 0 1 64 832V384a128 128 0 0 1 128-128v64a64 64 0 0 0-64 64v448a64 64 0 0 0 64 64h448a64 64 0 0 0 64-64h64z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M384 128a64 64 0 0 0-64 64v448a64 64 0 0 0 64 64h448a64 64 0 0 0 64-64V192a64 64 0 0 0-64-64H384zm0-64h448a128 128 0 0 1 128 128v448a128 128 0 0 1-128 128H384a128 128 0 0 1-128-128V192A128 128 0 0 1 384 64z"
  })
], -1))
const _hoisted_42 = { class: "badge badge-light-primary" }
const _hoisted_43 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_44 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "el-dropdown-link",
  style: {"display":"flex","justify-content":"center"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/icons/duotune/general/gen059.svg",
    style: {"width":"16px","height":"16px"},
    alt: "img"
  })
], -1))
const _hoisted_46 = /*#__PURE__*/_createTextVNode("Edit")
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" Statement ")
const _hoisted_48 = /*#__PURE__*/_createTextVNode("Adjustment ")
const _hoisted_49 = /*#__PURE__*/_createTextVNode("Withdraw")
const _hoisted_50 = { style: {"margin-left":"10px"} }
const _hoisted_51 = /*#__PURE__*/_createTextVNode("Reason: ")
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_53 = { style: {"display":"flex","justify-content":"center","margin-bottom":"15px"} }
const _hoisted_54 = {
  class: "card card-flush",
  style: {"width":"700px","border-color":"lightgray","border-style":"solid","border-width":"1px"}
}
const _hoisted_55 = { class: "card-body py-5" }
const _hoisted_56 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_57 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_58 = /*#__PURE__*/_createTextVNode("Confirm")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_check_tag = _resolveComponent("el-check-tag")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_alert, {
      style: {"margin-top":"-35px"},
      title: "Wallet setup feature will be released in next version! Currently please contact IT team for help.",
      type: "warning",
      "show-icon": "",
      closable: false
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("ul", _hoisted_4, [
            _createElementVNode("li", _hoisted_5, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", { 'active' : _ctx.isBalanceActive}]),
                "data-bs-toggle": "tab",
                href: "#balance",
                click: _ctx.chooseProfile
              }, "Balance ", 10, _hoisted_6)
            ]),
            _createElementVNode("li", _hoisted_7, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", { 'active' : _ctx.isWalletActive}]),
                click: _ctx.chooseWallet,
                "data-bs-toggle": "tab",
                href: "#wallet"
              }, "Account(s)", 10, _hoisted_8)
            ]),
            _createElementVNode("li", _hoisted_9, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", { 'active' : _ctx.isProfileActive}]),
                "data-bs-toggle": "tab",
                href: "#profile",
                click: _ctx.chooseProfile
              }, "Merchant Info ", 10, _hoisted_10)
            ]),
            _createElementVNode("li", _hoisted_11, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", { 'active' : _ctx.isRiskActive}]),
                "data-bs-toggle": "tab",
                href: "#risk",
                click: _ctx.chooseProfile
              }, "Risk&Compliance ", 10, _hoisted_12)
            ]),
            _createElementVNode("li", _hoisted_13, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", { 'active' : _ctx.isSettingActive}]),
                "data-bs-toggle": "tab",
                href: "#setting",
                click: _ctx.chooseProfile
              }, "Merchant Setting ", 10, _hoisted_14)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", {
            class: _normalizeClass(["tab-pane fade", { 'active' : _ctx.isBalanceActive, 'show' : _ctx.isBalanceActive }]),
            id: "balance",
            role: "tabpanel"
          }, [
            _withDirectives((_openBlock(), _createBlock(_component_el_descriptions, {
              title: _ctx.merchantRef ? _ctx.merchantRef.name : '',
              column: 1,
              direction: "vertical"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_descriptions_item, { label: "Total Available Balance:" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _hoisted_17,
                      _hoisted_18,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedFiatWallets.filter(it => it.availableBalance!==0), (item) => {
                        return (_openBlock(), _createBlock(_component_el_check_tag, {
                          checked: "",
                          style: {"margin-right":"8px"},
                          onClick: ($event: any) => (_ctx.showCurrencyWallet(item.currency)),
                          key: item.currency
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("$" + _toDisplayString(" "+ item.availableBalance + " " + item.currency), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ]),
                    _hoisted_19,
                    _createElementVNode("div", null, [
                      _hoisted_20,
                      _hoisted_21,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedCryptoWallets.filter(it => it.availableBalance!==0), (item) => {
                        return (_openBlock(), _createBlock(_component_el_check_tag, {
                          checked: "",
                          style: {"margin-right":"8px"},
                          onClick: ($event: any) => (_ctx.showCurrencyWallet(item.currency)),
                          key: item.currency
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("$" + _toDisplayString(" "+ item.availableBalance + " " + item.currency), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "Total Reserve Balance:" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _hoisted_22,
                      _hoisted_23,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedFiatWallets.filter(it => it.unavailableBalance!==0), (item) => {
                        return (_openBlock(), _createBlock(_component_el_check_tag, {
                          style: {"margin-right":"8px"},
                          onClick: ($event: any) => (_ctx.showCurrencyWallet(item.currency)),
                          key: item.currency
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("$" + _toDisplayString(" "+ item.unavailableBalance + " " + item.currency), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ]),
                    _hoisted_24,
                    _createElementVNode("div", null, [
                      _hoisted_25,
                      _hoisted_26,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedCryptoWallets.filter(it => it.unavailableBalance!==0), (item) => {
                        return (_openBlock(), _createBlock(_component_el_check_tag, {
                          style: {"margin-right":"8px"},
                          key: item.currency
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("$" + _toDisplayString(" "+ item.unavailableBalance + " " + item.currency) + " @click=\"showCurrencyWallet(item.currency)\" ", 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _hoisted_27,
                    _hoisted_28
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["title"])), [
              [_directive_loading, _ctx.loadingRef]
            ]),
            _createElementVNode("h4", _hoisted_29, _toDisplayString(_ctx.currencyTab) + " Account(s) ", 1),
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: _ctx.balanceWalletsRef,
              style: {"width":"100%"},
              height: "600",
              size: "default"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  fixed: "",
                  prop: "id",
                  label: "Id",
                  width: "80"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "slug",
                  label: "Slug",
                  width: "250"
                }, {
                  default: _withCtx((props) => [
                    _createElementVNode("div", {
                      onClick: ($event: any) => (_ctx.copySlug(props.row.slug))
                    }, [
                      _createTextVNode(_toDisplayString(props.row.slug.toString().substring(0,18) +"... ") + " ", 1),
                      _hoisted_31
                    ], 8, _hoisted_30)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "name",
                  label: "Name",
                  width: "250"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "currency",
                  label: "currency",
                  width: "120"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "availableBalance",
                  label: "Available Balance",
                  width: "160"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "unavailableBalance",
                  label: "Unavailable Balance",
                  width: "170"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "enabled",
                  label: "Status",
                  width: "100",
                  fixed: "right"
                }, {
                  default: _withCtx((statusTag) => [
                    (statusTag.row.enabled === true)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_32, "Active"))
                      : _createCommentVNode("", true),
                    (statusTag.row.enabled === false)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_33, "Disabled"))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, _ctx.loadingRef]
            ]),
            _createVNode(_component_el_pagination, {
              currentPage: _ctx.balancePageNumberRef,
              "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.balancePageNumberRef) = $event)),
              "page-size": _ctx.balancePageSizeRef,
              small: _ctx.small,
              "page-sizes": [20, 30, 40, 50],
              layout: "total,sizes, prev, pager, next",
              total: _ctx.balanceTotalRef,
              style: {"float":"right","margin-top":"10px"},
              background: "",
              onSizeChange: _ctx.updateBalanceWalletPageSize,
              onCurrentChange: _ctx.updateBalanceWalletPageNumber
            }, null, 8, ["currentPage", "page-size", "small", "total", "onSizeChange", "onCurrentChange"])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["tab-pane fade", { 'active' : _ctx.isRiskActive, 'show' : _ctx.isRiskActive }]),
            id: "risk",
            role: "tabpanel"
          }, null, 2),
          _createElementVNode("div", {
            class: _normalizeClass(["tab-pane fade", { 'active' : _ctx.isSettingActive, 'show' : _ctx.isSettingActive }]),
            id: "setting",
            role: "tabpanel"
          }, null, 2),
          _createElementVNode("div", {
            class: _normalizeClass(["tab-pane fade", { 'active' : _ctx.isProfileActive, 'show' : _ctx.isProfileActive }]),
            id: "profile",
            role: "tabpanel"
          }, [
            (_ctx.merchantRef)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createElementVNode("h4", null, _toDisplayString(_ctx.merchantRef.name), 1)
                ]))
              : _createCommentVNode("", true),
            _hoisted_35
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["tab-pane fade", { 'active' : _ctx.isWalletActive, 'show':_ctx.isWalletActive}]),
            id: "wallet",
            role: "tabpanel"
          }, [
            _hoisted_37,
            _hoisted_38,
            _hoisted_39,
            _createVNode(_component_el_table, {
              data: _ctx.walletsRef,
              style: {"width":"100%"},
              height: "550",
              size: "default"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  fixed: "",
                  prop: "id",
                  label: "Id",
                  width: "80"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "slug",
                  label: "Slug",
                  width: "250"
                }, {
                  default: _withCtx((props) => [
                    _createElementVNode("div", {
                      onClick: ($event: any) => (_ctx.copySlug(props.row.slug))
                    }, [
                      _createTextVNode(_toDisplayString(props.row.slug.toString().substring(0,18) +"... ") + " ", 1),
                      _hoisted_41
                    ], 8, _hoisted_40)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "name",
                  label: "Name",
                  width: "250"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "availableBalance",
                  label: "Balance",
                  width: "140"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "unavailableBalance",
                  label: "U/N Balance",
                  width: "140"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "currency",
                  label: "Credit Currency",
                  width: "140"
                }, {
                  default: _withCtx((cc) => [
                    _createElementVNode("span", _hoisted_42, _toDisplayString(cc.row.currency), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "collectionCurrencies",
                  label: "Collection Currency",
                  width: "180"
                }, {
                  default: _withCtx((cc) => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cc.row.collectionCurrencies, (item) => {
                      return (_openBlock(), _createElementBlock("span", {
                        class: "badge badge-light-primary",
                        key: item,
                        style: {"margin-right":"5px"}
                      }, _toDisplayString(item), 1))
                    }), 128))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "settlementCurrencies",
                  label: "Settle Currency",
                  width: "140"
                }, {
                  default: _withCtx((sc) => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sc.row.settlementCurrencies, (item) => {
                      return (_openBlock(), _createElementBlock("span", {
                        class: "badge badge-light-primary",
                        key: item,
                        style: {"margin-right":"5px"}
                      }, _toDisplayString(item), 1))
                    }), 128))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "gateways",
                  label: "APM",
                  width: "250"
                }, {
                  default: _withCtx((gatewaysArray) => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gatewaysArray.row.gateways, (item) => {
                      return (_openBlock(), _createElementBlock("span", {
                        class: "badge badge-light-info",
                        key: item,
                        style: {"margin-right":"5px"}
                      }, _toDisplayString(item), 1))
                    }), 128))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "createdAt",
                  label: "Created At",
                  width: "250"
                }, {
                  default: _withCtx((createdDate) => [
                    _createTextVNode(_toDisplayString(_ctx.DateTimeUtils.parseDateTime(createdDate.row.createdAt)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "enabled",
                  label: "Status",
                  width: "100",
                  fixed: "right"
                }, {
                  default: _withCtx((statusTag) => [
                    (statusTag.row.enabled === true)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_43, "Active"))
                      : _createCommentVNode("", true),
                    (statusTag.row.enabled === false)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_44, "Disabled"))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "action",
                  label: "Action",
                  fixed: "right",
                  width: "80"
                }, {
                  default: _withCtx((wallet) => [
                    _createVNode(_component_el_dropdown, null, {
                      dropdown: _withCtx(() => [
                        _createVNode(_component_el_dropdown_menu, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_dropdown_item, { disabled: "" }, {
                              default: _withCtx(() => [
                                _hoisted_46
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_dropdown_item, {
                              onClick: ($event: any) => (_ctx.showStatement(wallet.row.id))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_47
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_el_dropdown_item, {
                              onClick: ($event: any) => (_ctx.showAdjustment(wallet.row))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_48
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_el_dropdown_item, null, {
                              default: _withCtx(() => [
                                _hoisted_49
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      default: _withCtx(() => [
                        _hoisted_45
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_el_pagination, {
              currentPage: _ctx.pageNumberRef,
              "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pageNumberRef) = $event)),
              "page-size": _ctx.pageSizeRef,
              small: _ctx.small,
              "page-sizes": [20, 30, 40, 50],
              layout: "total,sizes, prev, pager, next",
              total: _ctx.totalRef,
              style: {"float":"right","margin-top":"10px"},
              onSizeChange: _ctx.updatePageSize,
              onCurrentChange: _ctx.updatePageNumber,
              background: ""
            }, null, 8, ["currentPage", "page-size", "small", "total", "onSizeChange", "onCurrentChange"])
          ], 2)
        ])
      ])
    ]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.statementDrawer,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.statementDrawer) = $event)),
      title: "Wallet Statement",
      direction: 'rtl',
      size: "1500px",
      "before-close": _ctx.handleClose
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: _ctx.walletStatementsRef,
          style: {"width":"100%"},
          height: "600",
          size: "default"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              type: "expand",
              fixed: "",
              width: "20"
            }, {
              default: _withCtx((walletStatement) => [
                _createElementVNode("p", _hoisted_50, [
                  _hoisted_51,
                  _hoisted_52,
                  _createTextVNode(_toDisplayString(walletStatement.row.remarks), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "id",
              label: "ID",
              width: "80"
            }),
            _createVNode(_component_el_table_column, {
              prop: "merchantId",
              label: "Merchant",
              width: "250"
            }, {
              default: _withCtx((walletStatement) => [
                _createTextVNode(_toDisplayString(walletStatement.row.merchant? (walletStatement.row.merchant.name +"-"+walletStatement.row.merchantId ):"-"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "walletId",
              label: "Wallet",
              width: "250"
            }, {
              default: _withCtx((walletStatement) => [
                _createTextVNode(_toDisplayString(walletStatement.row.wallet? (walletStatement.row.wallet.name +"-"+walletStatement.row.walletId):"-"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "type",
              label: "Type",
              width: "130"
            }),
            _createVNode(_component_el_table_column, {
              prop: "currency",
              label: "currency",
              width: "120"
            }),
            _createVNode(_component_el_table_column, {
              prop: "balanceType",
              label: "Change Balance",
              width: "200"
            }),
            _createVNode(_component_el_table_column, {
              prop: "amount",
              label: "Change Amount",
              width: "200"
            }),
            _createVNode(_component_el_table_column, {
              prop: "availableBalance",
              label: "Available Balance",
              width: "160"
            }),
            _createVNode(_component_el_table_column, {
              prop: "unavailableBalance",
              label: "Unavailable Balance",
              width: "170"
            }),
            _createVNode(_component_el_table_column, {
              prop: "createdAt",
              label: "Created At",
              width: "250"
            }, {
              default: _withCtx((walletStatement) => [
                _createTextVNode(_toDisplayString(_ctx.DateTimeUtils.parseDateTime(walletStatement.row.createdAt)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "updatedAt",
              label: "Updated At",
              width: "250"
            }, {
              default: _withCtx((walletStatement) => [
                _createTextVNode(_toDisplayString(_ctx.DateTimeUtils.parseDateTime(walletStatement.row.updatedAt)), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, _ctx.loadingRef]
        ]),
        _createVNode(_component_el_pagination, {
          currentPage: _ctx.walletStatementPageNumberRef,
          "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.walletStatementPageNumberRef) = $event)),
          "page-size": _ctx.walletStatementPageSizeRef,
          small: _ctx.small,
          "page-sizes": [20, 30, 40, 50],
          layout: "total,sizes, prev, pager, next",
          total: _ctx.walletStatementTotalRef,
          style: {"float":"right","margin-top":"10px"},
          background: "",
          onSizeChange: _ctx.updateWalletStatementPageSize,
          onCurrentChange: _ctx.updateWalletStatementPageNumber
        }, null, 8, ["currentPage", "page-size", "small", "total", "onSizeChange", "onCurrentChange"])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.adjustmentDrawer,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.adjustmentDrawer) = $event)),
      title: "Wallet Adjustment",
      direction: 'rtl',
      size: "800px",
      "before-close": _ctx.handleClose
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _createVNode(_component_el_descriptions, {
                class: "margin-top",
                title: _ctx.selectWallet? _ctx.selectWallet.name :'-',
                column: 3,
                size: _ctx.small
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_descriptions_item, { label: "Wallet ID:" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.selectWallet? _ctx.selectWallet.id : "-"), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "Merchant ID:" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.selectWallet? _ctx.selectWallet.merchantId : "-"), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "Available Balance:" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.selectWallet? (_ctx.selectWallet.availableBalance + " "+ _ctx.selectWallet.currency): "-"), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "Unavailable Balance:" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.selectWallet? (_ctx.selectWallet.unavailableBalance + " " + _ctx.selectWallet.currency):"-"), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "Status:" }, {
                    default: _withCtx(() => [
                      (_ctx.selectWallet.enabled)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_56, "Active"))
                        : _createCommentVNode("", true),
                      (!_ctx.selectWallet.enabled)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_57, "Disabled"))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["title", "size"])
            ])
          ])
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_form, {
          ref: "adjustFormRef",
          model: _ctx.adjustForm,
          "label-width": "170px",
          "label-position": "left",
          style: {"width":"700px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "Adjust Balance Type",
              required: "",
              prop: "balanceType"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.adjustForm.balanceType,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.adjustForm.balanceType) = $event)),
                  placeholder: "please select a type",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "Available Balance",
                      value: "Available"
                    }),
                    _createVNode(_component_el_option, {
                      label: "Unavailable Balance",
                      value: "Unavailable"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Adjustment",
              required: "",
              prop: "amount"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.adjustForm.amount,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.adjustForm.amount) = $event)),
                  placeholder: "Please input a amount",
                  class: "input-with-select",
                  type: "number"
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.adjustForm.adjustType,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.adjustForm.adjustType) = $event)),
                      placeholder: "Type",
                      style: {"width":"130px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "Increase",
                          value: "increase"
                        }),
                        _createVNode(_component_el_option, {
                          label: "Decrease",
                          value: "decrease"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  append: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.selectWallet? _ctx.selectWallet.currency:"-"), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Reason",
              required: "",
              prop: "reason"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("textarea", {
                  rows: 2,
                  type: "textarea",
                  style: {"width":"100%"},
                  placeholder: "Please input the reason for adjustment",
                  class: "el-textarea__inner",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.adjustForm.reason) = $event))
                }, "\r\n                         ", 512), [
                  [
                    _vModelText,
                    _ctx.adjustForm.reason,
                    void 0,
                    { lazy: true }
                  ]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _ctx.confirmAdjust
                }, {
                  default: _withCtx(() => [
                    _hoisted_58
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])), [
          [_directive_loading, _ctx.loadingRef]
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"])
  ], 64))
}